import L from 'leaflet';

const iconeNormal = new L.Icon({
    iconUrl: require('./iconeNormal.png'),
    iconRetinaUrl: require('./iconeNormal.png'),
    iconAnchor: [20, 30],
    iconSize: new L.Point(15, 25),
});
const customIcon = (conteudo) => {
    return new L.DivIcon({
        html: conteudo,
        iconAnchor: [20, 30],
        iconSize: new L.Point(15, 25),
        className: "teste"
    });
}
export { iconeNormal, customIcon };